import { useEffect } from 'react';
import { fetchBirthdayRequestRecommendations } from '@repo/redux/actions/birthdays';
import { openModal, selectActiveModalType } from '@repo/redux/actions/ui';
import { useAuthContext } from '@repo/hooks';
import { selectBirthdayRequestRecommendations } from '@repo/redux/reducers/data/birthdays';
import { useDispatch, useSelector } from 'react-redux';

export default function RequestMissingBirthdaysCallout({
  dismissCallout,
}: {
  dismissCallout?: () => void;
}) {
  const dispatch = useDispatch();
  const { user } = useAuthContext();
  const birthdayRequestRecommendations = useSelector(selectBirthdayRequestRecommendations);
  const activeModal = useSelector(selectActiveModalType);

  useEffect(() => {
    dispatch(fetchBirthdayRequestRecommendations());
  }, []);

  useEffect(() => {
    if (
      user.has_completed_onboarding &&
      birthdayRequestRecommendations.length > 0 &&
      !activeModal
    ) {
      dispatch(openModal('requestMissingBirthdays', { source: 'userCallout' }));
      dismissCallout();
    }
  }, [birthdayRequestRecommendations]);

  return null;
}
